import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Two Factor Authentication/MFA", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { style: {"max-width":"1000px"} }, " We use TOTP (Time-based One Time Password) technologies for two-factor authentication. Using the button below you can generate a QR code, which you can scan and open in your phone's TOTP supported application. After generating the security QR code, you'll be prompted to enter the verification code every time you log in. The supported applications are listed below, but many authenticator apps work the same, should you choose to use your own preferred application ", -1)
const _hoisted_3 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_4 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" App Store: ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { id: "iOS-Google" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/cz/app/google-authenticator/id388497605",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " Google Authenticator ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { id: "iOS-Microsoft" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://apps.apple.com/cz/app/microsoft-authenticator/id983156458",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " Microsoft Authenticator ")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Google Play: ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", { id: "Android-Google" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " Google Authenticator ")
  ]),
  /*#__PURE__*/_createElementVNode("li", { id: "Android-Microsoft" }, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://play.google.com/store/apps/details?id=com.azure.authenticator",
      target: "_blank",
      rel: "noopener noreferrer"
    }, " Microsoft Authenticator ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ViewTemplate = _resolveComponent("ViewTemplate")!

  return (_openBlock(), _createBlock(_component_ViewTemplate, { title: "User Settings" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      (_ctx.alreadySet)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " 2FA token is already set for you. Generating new one will invalidate current one! "))
        : _createCommentVNode("", true),
      (_ctx.disabledInBe)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "2FA is disabled."))
        : _createCommentVNode("", true),
      _createVNode(_component_Button, {
        label: "Generate QR",
        onClick: _ctx.googleAuth,
        disabled: _ctx.disabledInBe
      }, null, 8, ["onClick", "disabled"]),
      _hoisted_5,
      (_ctx.googleAuthImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: 'data:image/jpeg;base64, ' + _ctx.googleAuthImage,
            alt: "Alt"
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true),
      _hoisted_7,
      _hoisted_8,
      _hoisted_9,
      _hoisted_10,
      _hoisted_11
    ]),
    _: 1
  }))
}